var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pdf-box" },
    [
      _c("pdf", { ref: "pdf", attrs: { src: _vm.pdfUrls } }),
      _vm._v(" "),
      _c(
        "van-button",
        {
          staticClass: "submit",
          attrs: { type: "primary", block: "" },
          on: { click: _vm.handleSubmit }
        },
        [_vm._v("下载")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ab866af2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ab866af2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/invoicing/invoicingPreview.vue
// module id = null
// module chunks = 